import React, { FC } from 'react';

import Typography from '@mui/material/Typography';

import { useBalance } from '@services/contract/common/erc20.contract';

import {
  authorizationActions,
  useAuth,
} from '@contexts/common/AuthorizationContext';

import { getShortAddress } from '@helpers/common/address.helpers';

import { formatBNWithCommas } from '@utils/formaters.utils';

import Button from '@components/common/Button';
import CopyClipboard from '@components/common/CopyClipboard';
import ModalWrapper from '@components/common/Modal/ModalWrapper';

import { ZERO_ADDRESS } from '@constants/common/chain.constants';
import { NATIVE_TOKEN } from '@constants/common/tokens.constants';
import { Variant } from '@constants/common/ui.constants';

import useStyles from './styles.module';

const AccountModal: FC = () => {
  const { classes } = useStyles();
  const { account, chainId } = useAuth();

  const { balance } = useBalance({
    tokenAddress: ZERO_ADDRESS,
    chainId,
  });

  return (
    <ModalWrapper title="Your wallet">
      <div className={classes.container}>
        <div className={classes.block}>
          <CopyClipboard value={account as string}>
            <Typography variant="h3">{getShortAddress(account)}</Typography>
          </CopyClipboard>
          {chainId && balance && (
            <Typography variant="body2" color={(theme) => theme.secondary.s3}>
              {formatBNWithCommas(
                balance,
                4,
                NATIVE_TOKEN[chainId].decimals,
                true,
              )}{' '}
              {NATIVE_TOKEN[chainId].symbol}
            </Typography>
          )}
        </div>
        <Button
          variant={Variant.Secondary}
          onClick={() => authorizationActions.handleDisconnect()}
        >
          Disconnect
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default AccountModal;
